import React from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatTile from '../../shared/StatTile'

export default withTranslation()(function BranchesStats({ t }) {
  const { data: branchesRes } = useSWR('merchants/branches')
  const { data: posRes } = useSWR('pos')

  const branches = branchesRes?.data ?? []
  const posDevices = posRes?.data ?? []

  const activeBranches = branches.filter((branch) => branch.status === 'active').length
  const inactiveBranches = branches.length - activeBranches
  const activePos = posDevices.filter((device) => device.status === 'active').length

  const pct = (count) => branches.length ? Math.round((count / branches.length) * 100) : 0

  return (
    <div className="grid gap-4 md:grid-cols-4 mb-5">
      <StatTile
        icon={UIcons.UilBuilding}
        label={t('settings.branch.stats.total')}
        value={branches.length}
        tone="primary"
      />

      <StatTile
        icon={UIcons.UilCheckCircle}
        label={t('settings.branch.stats.active')}
        value={activeBranches}
        sub={`${pct(activeBranches)}%`}
        tone="success"
      />

      <StatTile
        icon={UIcons.UilBuilding}
        label={t('settings.branch.stats.inactive')}
        value={inactiveBranches}
        sub={`${pct(inactiveBranches)}%`}
        tone="danger"
      />

      <StatTile
        icon={UIcons.UilDesktop}
        label={t('settings.branch.stats.active_pos')}
        value={activePos}
        tone="purple"
      />
    </div>
  )
})
